import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import QuoteModal from "./QuoteModal";


function Home() {
  const [showQuote, setShowQuote] = useState(false);

  return (
    <>
    <Helmet>
        <title>Commercial Cleaning Christchurch | Office &amp; Warehouse Cleaning NZ</title>
        <meta name="description" content="Clear &amp; Clean provides professional commercial cleaning services in Christchurch and the Canterbury region — office cleaning, industrial cleaning, warehouse and specialist cleaning." />
        <meta name="keywords" content="commercial cleaning Christchurch, office cleaning Christchurch, warehouse cleaning Canterbury, industrial cleaners NZ, commercial cleaners CHCH" />
        <meta name="robots" content="index, follow, max-snippet:-1, max-image-preview:large" />
        <link rel="canonical" href="https://www.clearandclean.co.nz/" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Clear &amp; Clean" />
        <meta property="og:url" content="https://www.clearandclean.co.nz/" />
        <meta property="og:title" content="Commercial Cleaning Christchurch | Clear &amp; Clean" />
        <meta property="og:description" content="Reliable commercial and specialist cleaning services across Christchurch and Canterbury." />
        <meta property="og:image" content="https://www.clearandclean.co.nz/images/bg_1.jpg" />
        <meta property="og:image:alt" content="Clear &amp; Clean commercial cleaning services" />
        <meta property="og:locale" content="en_NZ" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Commercial Cleaning Christchurch | Clear &amp; Clean" />
        <meta name="twitter:description" content="Professional commercial cleaning services in Christchurch and Canterbury." />
        <meta name="twitter:image" content="https://www.clearandclean.co.nz/images/bg_1.jpg" />

        {/* Structured Data — LocalBusiness */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Clear & Clean",
            "url": "https://www.clearandclean.co.nz",
            "telephone": "+64220866040",
            "email": "info@clearandclean.co.nz",
            "image": "https://www.clearandclean.co.nz/images/bg_1.jpg",
            "description": "Professional commercial cleaning company serving Christchurch and Canterbury.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "23 Conailles Street",
              "addressLocality": "Halswell",
              "addressRegion": "Canterbury",
              "postalCode": "8025",
              "addressCountry": "NZ"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": -43.5745,
              "longitude": 172.5899
            },
            "areaServed": {
              "@type": "City",
              "name": "Christchurch"
            },
            "serviceType": ["Commercial Cleaning", "Office Cleaning", "Warehouse Cleaning", "Industrial Cleaning"],
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
                "opens": "07:00",
                "closes": "18:00"
              },
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": "Saturday",
                "opens": "08:00",
                "closes": "16:00"
              }
            ],
            "priceRange": "$$",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "4.9",
              "reviewCount": "47",
              "bestRating": "5",
              "worstRating": "1"
            },
            "sameAs": []
          }
        `}</script>

      </Helmet>
      <div>
        <div className="hero-wrap js-fullheight" style={{backgroundImage: 'url("images/bg_1.jpg")'}} data-stellar-background-ratio="0.5">
          <div className="overlay" />
          <div className="container">
            <div className="row no-gutters slider-text js-fullheight align-items-center justify-content-start" data-scrollax-parent="true">
              <div className="col-md-6 ftco-animate">
<h2 className="subheading">Professional cleaning services you can trust with 15 years of experience.</h2>
                <h1 className="mb-4">Let us do the dirty work, so you don't have to.</h1>
                <p style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                  <Link to="/contact" className="btn btn-primary py-2 px-4">Get in touch <span className="ion-ios-arrow-forward" /></Link>
                  <button
                    onClick={() => setShowQuote(true)}
                    className="btn btn-outline-light py-2 px-4"
                    style={{ borderRadius: 4 }}
                  >
                    Get a Free Quote
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
        {}
        <section className="ftco-section ftco-no-pb">
          <div className="container">
            <div className="row d-flex no-gutters">
              <div className="col-md-6 d-flex">
                <div className="img d-flex align-items-center justify-content-center py-5 py-md-0" style={{backgroundImage: 'url(images/about.jpg)'}}>
                  <div className="time-open-wrap">
                    <div className="desc p-4">
                      <h2>CLEAR &amp; CLEAN</h2>
                      <div className="opening-hours">
                        <h4>Clear Promises. Clean Results.</h4>
                        <p className="pl-3">
                          <span>Comprehensive Commercial &amp; <br />Specialist Cleaning Services</span>
                          <span>Christchurch &amp; Canterbury Region</span>
                        </p>
                      </div>
                    </div>
                    {/* <div class="desc p-4 bg-secondary">
									<h3 class="heading">For Emergency Cases</h3>
									<span class="phone">(+01) 123 456 7890</span>
								</div> */}
                  </div>
                </div>
              </div>
              <div className="col-md-6 pl-md-5 pt-md-5">
                <div className="row justify-content-start py-5">
                  <div className="col-md-12 heading-section ftco-animate">
                    <h2 className="mb-4">Welcome to CLEAR &amp; CLEAN</h2>
                    <p>CLEAR &amp; CLEAN is a full-service professional cleaning company delivering
                      high-standard commercial and specialist cleaning solutions throughout
                      Christchurch and Canterbury. Our company was established with a strong
                      commitment to reliability, transparency, and long-term client partnerships.</p>
                    <p>
                      We understand that cleaning is directly connected to workplace health, safety
                      compliance, presentation standards, and staff wellbeing. For this reason, we
                      operate structured supervision systems, scheduled quality inspections, and clearly
                      defined service procedures across every site.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="ftco-section">
          <div className="container">
            <div className="row justify-content-center pb-5 mb-3">
              <div className="col-md-7 heading-section text-center ftco-animate">
                <span className="subheading">Services</span>
                <h2>Commercial Cleaning Services</h2>
              </div>
            </div>
            <div className="row mb-6">
              <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
                <div className="staff">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_1.jpg)'}} />
                  </div>
                  <div className="text pt-3 px-3 pb-4">
                    <h3 className="heading">Office &amp; Workplace Cleaning</h3>
                    <p>Comprehensive daily or scheduled cleaning
                      including workstations, kitchens, washrooms, meeting rooms, flooring, and
                      high-touch surfaces. Designed to maintain professional presentation and
                      hygiene compliance.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
                <div className="staff">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_2.jpg)'}} />
                  </div>
                  <div className="text pt-3 px-3 pb-4">
                    <h3 className="heading">Retail &amp; Showroom Cleaning</h3>
                    <p>Cleaning services tailored for customer-facing
                      environments where presentation and first impressions are critical.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
                <div className="staff">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_3.jpg)'}} />
                  </div>
                  <div className="text pt-3 px-3 pb-4">
                    <h3 className="heading">Industrial &amp; Warehouse Cleaning</h3>
                    <p>Comprehensive daily or scheduled cleaning
                      including workstations, kitchens, washrooms, meeting rooms, flooring, and
                      high-touch surfaces. Designed to maintain professional presentation and
                      hygiene compliance.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
                <div className="staff">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_4.jpg)'}} />
                  </div>
                  <div className="text pt-3 px-3 pb-4">
                    <h3 className="heading">Medical &amp; Healthcare Cleaning</h3>
                    <p>High-level sanitation and infection control
                      procedures following strict hygiene standards.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
                <div className="staff">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_5.jpg)'}} />
                  </div>
                  <div className="text pt-3 px-3 pb-4">
                    <h3 className="heading">Education &amp; School Cleaning</h3>
                    <p>Safe, child-conscious cleaning systems
                      ensuring hygienic learning environments with compliant processes.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
                <div className="staff">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch" style={{backgroundImage: 'url(images/service_6.jpg)'}} />
                  </div>
                  <div className="text pt-3 px-3 pb-4">
                    <h3 className="heading"> Common Area &amp; Facility Cleaning</h3>
                    <p>Cleaning for shared building spaces
                      including lobbies, corridors, lifts, stairwells, and amenities.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-md-4 col-lg-4 ftco-animate d-flex fadeInUp ftco-animated">
                <div className="staff">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch" style={{backgroundImage: 'url(images/movein.jpg)'}} />
                  </div>
                  <div className="text pt-3 px-3 pb-4">
                    <h3 className="heading"> Move-In / Move-Out Cleaning</h3>
                    <p>End-of-tenancy or relocation cleaning
                      ensuring properties are presented to high professional standards.</p>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </section>
        <section className="ftco-section bg-services">
          <div className="container">
            <div className="row justify-content-center pb-5 mb-3">
              <div className="col-md-7 heading-section text-center ftco-animate">
                <h2>Deep &amp; Specialist Cleaning Services</h2>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_7.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading"> Floor Polishing &amp; Hard Floor Care</h3>
                    <p>Machine polishing, buffing, and protective
                      treatments for vinyl, tile, and hard flooring surfaces.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_1.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading"> Builders &amp; Post-Construction Cleaning</h3>
                    <p>Detailed debris removal, surface
                      polishing, dust elimination, and final presentation cleaning ready for
                      handover</p>
                  </div>
                </div>
              </div>
              {/* <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_2.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading">Move-In / Move-Out Cleaning</h3>
                    <p>End-of-tenancy or relocation cleaning
                      ensuring properties are presented to high professional standards.</p>
                  </div>
                </div>
              </div> */}
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_3.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading">  Deep &amp; Intensive Cleaning</h3>
                    <p>Comprehensive top-to-bottom cleaning for
                      facilities requiring restoration or periodic deep maintenance.</p>
                  </div>
                </div> 
              </div>
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_4.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading">  Carpet Steam Cleaning</h3>
                    <p> Professional extraction cleaning to remove stains,
                      odours, and embedded dirt while extending carpet lifespan.</p>
                  </div>
                </div> 
              </div>
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_6.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading">Internal &amp; External Window Cleaning</h3>
                    <p>Streak-free cleaning of glass surfaces
                      to enhance natural light and building appearance</p>
                  </div>
                </div>
              </div>
              
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_8.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading"> High-Touch Surface Sanitisation</h3>
                    <p>Targeted disinfection for frequently
                      touched areas to support workplace health standards.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_9.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading">Exterior &amp; Walkway Cleaning</h3>
                    <p>Pressure washing and exterior maintenance
                      cleaning.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 services ftco-animate">
                <div className="d-block d-flex">
                  <div className="img-wrap d-flex align-items-stretch">
                    <div className="img align-self-stretch"><img src="images/services_10.png" alt="" /></div>
                  </div>
                  <div className="media-body pl-3">
                    <h3 className="heading"> High Ceiling &amp; Wall Cleaning</h3>
                    <p> Specialist access cleaning for elevated or
                      hard-to-reach areas.</p>
                  </div>
                </div>
              </div>

                



            </div>
          </div>
        </section>
         <div>
        <section className="ftco-section ftco-intro" style={{backgroundImage: 'url("images/bg_3.jpg")'}} data-stellar-background-ratio="0.5">
          <div className="overlay" />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center">
                <h2>Quality Assurance &amp; Health and Safety</h2>
                <p className="text-white">CLEAR &amp; CLEAN operates structured quality control systems including supervisor
                  site visits, checklists, performance monitoring, and client feedback procedures.
                  We maintain strict adherence to health and safety regulations, safe chemical
                  handling, equipment maintenance standards, and staff training programmes to
                  ensure consistent compliance.</p>
              </div>
            </div>
          </div>
        </section>
        <section className="ftco-section ftco-pb" id="why-choose-us">
          <div className="container">
            <div className="row d-flex no-gutters">
              <div className="col-md-6 d-flex">
                <div className="img d-flex align-items-center justify-content-center py-5 py-md-0" style={{backgroundImage: 'url(images/image_3.jpg)'}}>
                </div>
              </div>
              <div className="col-md-6 pl-md-5 pt-md-5">
                <div className="row justify-content-start py-5">
                  <div className="col-md-12 heading-section ftco-animate fadeInUp ftco-animated" id="why-choose-us">
                    <h3 className="mb-4">Why Choose CLEAR &amp; CLEAN</h3>
                    <div className="why-us">
                      <ul>
                        <li>Locally Owned &amp; Operated</li>
                        <li> Fully Trained &amp; Insured Personnel</li>
                        <li>Health &amp; Safety Compliant Systems</li>
                        <li>Structured Supervision &amp; Accountability</li>
                        <li>Reliable Attendance &amp; Service Continuity</li>
                        <li>Transparent Communication &amp; Reportin</li>
                      </ul>
                    </div>
                  </div>
                </div>				
              </div>
            </div>
          </div>
        </section>
      </div>

      </div>
      {showQuote && <QuoteModal onClose={() => setShowQuote(false)} />}
      </>
    );
}

export default Home;